module.exports = __webpack_public_path__ + "img/big_clinic_blue.199d2c26.svg";